<template>
  <div class="items-center min-h-screen flex flex-col bg-white w-full">
    <div v-if="!documentMetadata" class="w-11/12">
      <div class="mt-4">
        <!-- Buscador -->
        <v-text-field
          id="documentsSearch"
          class="mx-3"
          flat
          label=""
          prepend-inner-icon="search"
          v-model="search"
          background-color=""
          clearable
          @click:clear="clearSearch"
          data-vs-textfield="documents-search">
        </v-text-field>
      </div>
      <!-- Lista -->
      <div class="main--container mt-4 shadow w-full bg-white">
        <vue-loading
            v-if="loading"
            background-color="rgba(0,0,0,0.0)"
            :active="loading"
            color="#4F41A3"
            :width="60"
            :height="60"
            :is-full-page="false"
        />
        <template v-if="filteredItems.length > 0">
          <zt-list-item
            @click="selectDocumentType(item)"
            v-for="(item, index) in filteredItems"
            :title="item.nombre"
            :key="index"
            class="mt-2"
          >
          <template slot="icon">
            <zt-icon name="file" class="custom-file-icon" />
          </template>
          </zt-list-item>
        </template>
        <template v-if="filteredItems.length === 0 && loading === false">
          <div class="flex flex-col justify-center items-center pb-12 pt-4">
            <div class="h-40">
              <graphic-base height="100%" width="100%" :viewBox="'0 0 160 120'">
                <EmptyStateSVG />
              </graphic-base>
            </div>
            <p class="text-zt-primary-200 text-base leading-5 pt-4 font-normal">{{$t("message.FileUploadComponent.emptyState")}}</p>
          </div>
        </template>
      </div>
    </div>
    <div v-else class="mt-4 w-11/12">
      <div>
        <dwt-form-generator
          @checkLoadAprove="checkLoadAprove=$event"
          @rollbackSelectedDoc="docTypeSelected=$event"
          @nullDocMetadata='documentMetadata=$event'
          @updateKey="componentKey=$event"
          :key="componentKey"
          :metadata="documentMetadata"
          imageText="Tomar foto"
          pdfText="Seleccionar archivo PDF" />
      </div>
    </div>
  </div>
</template>
<script>
import UploadFiles from "@/apiClient/UploadFiles";
import DwtFormGenerator from "@/components/generics/DWTFormGenerator";
import graphicBase from '@/components/commons/Illustrations/graphicBase'
import EmptyStateSVG from '@/components/commons/Illustrations/graphicSVG/graphicEmptyState'

export default {
  components: {
    DwtFormGenerator,
    graphicBase,
    EmptyStateSVG
  },
  data() {
    return {
      headerView: 5,
      loading: false,
      docTypeSelected: {},
      documentTypes: [],
      documentMetadata: null,
      documentFiles: {},
      componentKey: 0,
      checkLoadAprove: false,
      search: '',

    };
  },

  async created() {
    this.uploadFiles = new UploadFiles();
    this.getDocumentTypes();
  },
  update() {
  },
  computed: {
    filteredItems() {
      return _.orderBy(this.documentTypes.filter(documentType => {
        if(!this.search) {
          return this.documentTypes;
        }
        else {
          return (documentType.nombre.toLowerCase().includes(this.search.toLowerCase()));
        }
      }), 'nombre');
    }
  },
  watch: {
    'checkLoadAprove': function() {
      if(this.checkLoadAprove === true) {
        this.getDocumentTypes()
      }
    }
  },
  methods: {
    clearSearch() {
      this.search="";
    },
    getDocumentTypes() {
      this.loading = true;
      this.uploadFiles.getDocumentTypesList().then(response => {
          this.loading = false;
          this.documentTypes = response.data.results.data;
          this.checkLoadAprove = false
        })
        .catch(error => {
          this.loading = false;
          this.$swal({
              type: "error",
              title: this.$t(`message.errorReference.${error.response.data.code}`),
              showConfirmButton: true,
              confirmButtonText: this.$t("message.FileUploadComponent.swal.accept")
          });
        });
    },
    selectDocumentType(value) {
      this.documentMetadata = value;
      this.forceRerender()
    },
    forceRerender() {
      this.componentKey += 1;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../public/assets/scss/_config.scss";

.custom-file-icon{
  font-size: 2.5rem;
  align-self: center;
  color: #6f6f6f;
}

//stepper
.container-step {
  max-width: 100%;
  margin: 0 auto;
}

.step-indicator {
  margin-top: 50px;
  display: flex;
  align-items: center;
  //padding: 0 40px;
}

.step {
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  z-index: 1;
}

.step-indicator .step-icon {
  height: 13px;
  width: 13px;
  border-radius: 50%;
  background: #c2c2c2;
  //font-size: 10px;
  text-align: center;
  color: #ffffff;
  position: relative;
  line-height: 50px;
  font-size: 20px;
}

.step.active .step-icon {
  background: #54caa6;
}

.indicator-line {
  width: 100%;
  height: 2px;
  background: #c2c2c2;
  flex: 1;
}

.indicator-line.active {
  background: #54caa6;
}

.stepper-text {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: -35px;
}

.step-text {
  width: 20%;
  color: #2470a0;
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}

#step3 {
  padding-left: 18px;
}

@media screen and (max-width: 500px) {
  .step p {
    font-size: 11px;
    bottom: -20px;
  }
}
.flexUpload {
  padding: 0px!important;
}
.mbcUpdateContainer {
  margin-top: 0px;
  padding: 16px 0px;
}
</style>